import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import CONSTANTS from '../../_constants/constants';

import { SharedModule } from '../../_shared/shared.module';
import { AlertService } from '../../_shared/services/alert.service';
import { UtilService } from '../../_shared/services/util.service';

import { atLeastOneCheckboxCheckedValidator } from '../../_shared/validators/atLeastOneCheckboxCheckedValidator';

import { WhatToBring } from '../shared/what-to-bring.model';
import { WhatToBringModalService } from '../shared/what-to-bring-modal.service';
import { WhatToBringService } from '../shared/what-to-bring.service';

@Component({
  selector: 'app-what-to-bring-detail',
  templateUrl: './what-to-bring-detail.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class WhatToBringDetailComponent implements OnInit {
  constructor(
    private whatToBringService: WhatToBringService,
    private whatToBringModalService: WhatToBringModalService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private utilService: UtilService
  ) {}

  @Input() whatToBring: WhatToBring;
  @Input() mode: string;
  @Input() defaultLanguage;
  @Input() additionalLanguages;
  @Input() isModal = false;

  @Output() private savedWhatToBring = new EventEmitter<WhatToBring>();
  @Output() private canceledWhatToBring = new EventEmitter();

  form: FormGroup;
  formSubmited = false;

  createMode = false;
  editMode = false;
  viewMode = false;

  productTypes = CONSTANTS.ALL_PRODUCT_TYPES;

  allProductTypesChecked = false;

  serverErrors = [];
  sendingForm = false;

  // private whatToBringCopy;

  ngOnInit() {
    this.setWhatToBringForm();

    if (this.whatToBring.id) {
      this.setItemOptions(this.whatToBring, this.mode);
    } else {
      this.createMode = true;

      // In case we don't initialize the object in the parent component - to work with setProductTypesChecked
      if (!this.whatToBring.type) {
        this.whatToBring.type = {};
      }
    }

    this.setProductTypesChecked();
  }

  // Try to replace this, avoid get as possible
  get productTypesFormArray() {
    return this.form.controls['type'] as FormArray;
  }

  checkAllProductTypes(event) {
    this.allProductTypesChecked = event.target.checked; // checked

    this.productTypesFormArray.controls.forEach((x) => {
      x.setValue(event.target.checked);
    });
  }

  checkProductType(event) {
    if (!event.target.checked) {
      this.allProductTypesChecked = false;
    }
  }

  // Referenced from app-translation-options
  onOpenedTranslation(language) {
    this.whatToBringModalService.openWhatToBringTranslation(this.whatToBring, language);
  }

  // Referenced from app-item-detail-form-actions
  onSavedWhatToBring() {
    this.formSubmited = true;

    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const fields = ['name', 'description'];
    const formData = this.utilService.deleteNullFields(fields, this.form.value);

    formData.type = this.utilService.productTypesFormArrayChecked(
      this.productTypes,
      this.productTypesFormArray
    );

    this.sendingForm = true;

    this.whatToBringService
      .saveWhatToBring(this.whatToBring.id, formData, this.defaultLanguage.lang)
      .subscribe({
        next: (response) => {
          let msg = '';

          if (this.editMode) {
            msg = 'MODIFIED_WHAT_TO_BRING';

            // needed if we want to keep the page opened or if used in page
            this.whatToBring = response;
            this.setItemOptions(response);
          } else {
            msg = 'NEW_ADDED_WHAT_TO_BRING';
            // this.whatToBring = response; // reload item - needed ?
          }

          this.alertService.open(msg);

          // this.setItemOptions(response);

          this.sendingForm = false;

          this.savedWhatToBring.emit(response);
        },
        error: (response) => {
          this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

          this.sendingForm = false;
        },
      });
  }

  // Referenced from app-item-detail-form-actions
  onCanceled() {
    // if (this.editMode) {
    //   this.cancelEdit();
    //   return;
    // }

    this.canceledWhatToBring.emit();
  }

  // Referenced from app-item-detail-form-actions
  onEditedWhatToBring() {
    this.editMode = true;
    this.viewMode = false;

    this.enableDisableProductTypes('enable');
  }

  // private cancelEdit() {
  //   this.whatToBring = this.whatToBringCopy;
  //   this.setItemOptions(this.whatToBring);
  // }

  private setItemOptions(whatToBring, mode = '') {
    this.createMode = false;
    this.editMode = false;
    this.viewMode = true;

    if (mode === 'edit') {
      this.onEditedWhatToBring();
    }

    // this.whatToBringCopy = JSON.parse(JSON.stringify(whatToBring));
  }

  private setWhatToBringForm() {
    this.form = this.formBuilder.group({
      name: [
        this.whatToBring.name,
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: [this.whatToBring.description],
      type: new FormArray([], atLeastOneCheckboxCheckedValidator(1)),
    });
  }

  private setProductTypesChecked() {
    for (let productType of this.productTypes) {
      let isSelected = Object.keys(this.whatToBring.type).some((x) => x === productType.type);

      this.productTypesFormArray.push(new FormControl(isSelected));
    }

    const option = this.viewMode ? 'disable' : 'enable';

    this.enableDisableProductTypes(option);
  }

  private enableDisableProductTypes(option) {
    this.productTypesFormArray.controls.forEach((x) => {
      if (option === 'enable') {
        x.enable();
      } else {
        x.disable();
      }
    });
  }
}
